// import "core-js/stable";
// import "regenerator-runtime/runtime";
//
import './src/styles/pwa.scss'

import renderApp from './src/ui'

// reducer
import settingsSlice from './src/slices/settings'
import uiSlice from './src/slices/ui'
import mapSlice from './src/slices/map'
import geolocationSlice from './src/slices/geolocation'
import userPosition from './src/slices/userposition'
import profileSlice from './src/slices/profile'
import accommodationSlice from './src/slices/accommodation'
import plannerSlice from './src/slices/planner'

// urls
import urls from './src/urls'

// app
import App from './src/App'

// location
import location from './src/location'

const slices = [
  uiSlice,
  settingsSlice,
  geolocationSlice,
  userPosition,
  mapSlice,
  profileSlice,
  accommodationSlice,
  plannerSlice
]

const settings = {
  URLS: urls
}

renderApp(App, slices, settings, location)
